import BrowserbaseSourceIcon from "../../assets/components/sources/BrowserbaseSourceIcon";

const BrowserbaseLogomark = ({ height }: { height: number }) => {
  return <BrowserbaseSourceIcon height={height} />;
};

export default BrowserbaseLogomark;
